import { render, staticRenderFns } from "./RightUser.vue?vue&type=template&id=6667648c&scoped=true&"
import script from "./RightUser.vue?vue&type=script&lang=js&"
export * from "./RightUser.vue?vue&type=script&lang=js&"
import style0 from "./RightUser.vue?vue&type=style&index=0&id=6667648c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6667648c",
  null
  
)

export default component.exports